module.exports = global["sweetalert"] = require("-!/home/intellect/public_html/2016/sadywincenta.pl/shop/frontend/sadywincenta.pl/node_modules/sweetalert/lib/sweetalert.js");


/*****************
 ** WEBPACK FOOTER
 ** /home/intellect/public_html/2016/sadywincenta.pl/shop/frontend/sadywincenta.pl/~/expose-loader?sweetalert!/home/intellect/public_html/2016/sadywincenta.pl/shop/frontend/sadywincenta.pl/~/sweetalert/lib/sweetalert.js
 ** module id = 22
 ** module chunks = 0
 **/